import i18n from 'utils/i18n';
import { APIConstants } from 'utils/constants';

interface DifyApiPayload {
  inputs: {
    environment: string;
    user_pk: string;
    locale: string;
    action_type: string;
  };
  user: string;
}

interface DifyApiResponse {
  data?: {
    outputs?: {
      result?: string;
    };
  };
  message?: string;
}

export class BioPolishService {
  private static createRequestPayload(userID: string, actionType: string): DifyApiPayload {
    const locale = i18n.language === 'zh-Hant' ? 'zh_HK' : 'en';
    
    // Determine environment based on the actual domain being used
    const isLocalhost = window.location.hostname === 'localhost';
    const environment = isLocalhost 
      ? 'test' 
      : process.env.REACT_APP_DOMAIN?.includes('prod.goodmates.org') ? 'prod' : 'test';
    
    return {
      inputs: {
        environment: environment,
        user_pk: userID.toLowerCase(),
        locale: locale,
        action_type: actionType
      },
      user: `${environment}-${userID.toLowerCase()}`
    };
  }

  static async getUserBio(
    userID: string,
    actionType: 'generation' | 'polish' | 'highlight',
    authToken: string
  ): Promise<string> {
    const payload = this.createRequestPayload(userID, actionType);
    
    // Use current host if running on localhost, otherwise use REACT_APP_DOMAIN
    const isLocalhost = window.location.hostname === 'localhost';
    const baseUrl = isLocalhost
      ? `${window.location.protocol}//${window.location.host}`
      : process.env.REACT_APP_DOMAIN;

    const apiUrl = `${baseUrl}/api/dify/v1/workflows/run`;

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'accept-language': 'en',
          'authorization': `Bearer ${APIConstants.DIFY_API_KEY_BIO}`,
          'content-type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: DifyApiResponse = await response.json();
      
      // Extract the result from the response
      const result = data.data?.outputs?.result || '';
      
      if (!result) {
        throw new Error('No bio result received from API');
      }

      return result;
    } catch (error) {
      console.error('Error in getUserBio:', error);
      throw error;
    }
  }
}